import { fabric } from "fabric";
import { Registry } from "util/GenericRegistry";

export const canvasRegistry = new Registry<fabric.Canvas>();
